import { Entity } from '@backstage/catalog-model';

const KEY_NAME = 'keyName';
const ENVIRONMENT = 'environment';
const LOCATION = 'location';
const REPOSITORY = 'repository';
const GAT_EMAIL = 'gatEmail';
const ENVIRONMENT_VARIABLES_METADATA = 'environmentVariables';

export const isEnvironmentVariablesMetadataAvailable = (entity: Entity) =>
  Boolean(entity?.metadata?.[ENVIRONMENT_VARIABLES_METADATA]);

export const getKeyName = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[ENVIRONMENT_VARIABLES_METADATA]?.[KEY_NAME] ?? undefined;
};
export const getEmail = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[ENVIRONMENT_VARIABLES_METADATA]?.[GAT_EMAIL] ?? undefined;
};
export const getEnvironment = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[ENVIRONMENT_VARIABLES_METADATA]?.[ENVIRONMENT] ?? undefined;
};
export const getLocations = (entity: Entity): string[] | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[ENVIRONMENT_VARIABLES_METADATA]?.[LOCATION] ?? undefined;
};
export const getRepository = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[ENVIRONMENT_VARIABLES_METADATA]?.[REPOSITORY] ?? undefined;
};
